import React from 'react';

// Published media already includes refreshed URLs. Reuse those without private
// media queries, and try each distinct source at most once.
const ReadOnlyMessageImage = ({ image, ...props }) => {
    const sources = [...new Set([
        image?.thumbnail?.md,
        image?.thumbnail?.lg,
        image?.thumbnail?.sm,
        image?.thumbnail?.xl,
        image?.thumbnail?.original,
        image?.cdn_url,
        image?.url
    ].filter(source => typeof source === 'string' && source.trim()))];

    return sources.length ? <ImageWithFallback key={JSON.stringify(sources)} sources={sources} {...props} /> : null;
};

const ImageWithFallback = ({ sources, alt = '', ...props }) => {
    const [sourceIndex, setSourceIndex] = React.useState(0);
    if (sourceIndex >= sources.length) return null;
    return <img {...props} alt={alt} src={sources[sourceIndex]} onError={() => setSourceIndex(index => index + 1)} />;
};

export default ReadOnlyMessageImage;
